/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";

/**
 * Configure Git as the app source. Provide `repository` to connect it during
 *
 * @remarks
 * creation, or use an empty object to connect a repository later.
 */
export type AppGitCreateInput = {
  /**
   * The GitHub repository to connect, as "owner/repo". The workspace must have
   *
   * @remarks
   * the Teral GitHub App installed with access to it. Omit this field to create
   * the Git app before selecting its repository.
   */
  repository?: string | undefined;
  /**
   * The branch this app's deployments track. This requires `repository`.
   *
   * @remarks
   * Omit it to adopt the repository's default branch on GitHub.
   */
  defaultBranch?: string | undefined;
};

/** @internal */
export type AppGitCreateInput$Outbound = {
  repository?: string | undefined;
  defaultBranch?: string | undefined;
};

/** @internal */
export const AppGitCreateInput$outboundSchema: z.ZodType<
  AppGitCreateInput$Outbound,
  z.ZodTypeDef,
  AppGitCreateInput
> = z.object({
  repository: z.string().optional(),
  defaultBranch: z.string().optional(),
});

export function appGitCreateInputToJSON(
  appGitCreateInput: AppGitCreateInput,
): string {
  return JSON.stringify(
    AppGitCreateInput$outboundSchema.parse(appGitCreateInput),
  );
}
